import { useQuery, UseQueryResult } from 'react-query';
import { PayrollPeriodRetrieve } from 'types';
import { client } from 'utils/api-client';

function usePayrollPeriod(
  payrollPeriodId: string | undefined | null,
): UseQueryResult<{ data: PayrollPeriodRetrieve }> {
  return useQuery(
    ['payrollPeriods', payrollPeriodId],
    () => client.get(`payroll-periods/${payrollPeriodId}/`),
    {
      enabled: !!payrollPeriodId,
    },
  );
}

export default usePayrollPeriod;
